import styled from 'styled-components';
import Menu from '../../../Menu';

export const StyledMenu = styled(Menu)`
  .MuiPaper-root {
    min-width: 210px;
  }
`;
